"use client";
import React, { Suspense } from "react";
import { useRouter } from "next/navigation";
import { postNotification } from "bossjob-remote/dist/clientStorage";
import { encode } from "app/(jobs-hiring)/[lang]/jobs-hiring-old/interpreters/encoder";
// import Link from "next/link";
import { toPairs } from "ramda";
import styles from "./SimilarJobs.mobile.module.scss";

export default function ViewMore({ data, sessionid }) {
  const router = useRouter();
  const handleToHomePage = (data, sessionid) => {
    const searchQuery: any = {
      mainFunctions: [data?.main_function],
      jobFunctions: [data?.sub_function],
      workExperience: [data?.xp_lvl_seo_value]
    };
    if (!sessionid) {
      window?.sessionStorage?.setItem("redirectPage", window?.location?.pathname);
      postNotification("SHOW_LOGIN_MODAL");
      return;
    }
    if (data?.location_seo_value) {
      searchQuery.location = [data?.location_seo_value];
    }

    const result = encode(searchQuery);
    const url = new URLSearchParams(toPairs(result.params)).toString();
    router.push("/jobs-hiring/" + result.searchQuery + "?" + url);
  };
  return (
    <div className={styles.viewMore}>
      <Suspense>
        <a onClick={() => handleToHomePage(data?.more, sessionid)}>{data.more.text}</a>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='16'
          viewBox='0 0 17 16'
          fill='none'
        >
          <path
            d='M5.16602 11.3334L11.8327 4.66669M11.8327 4.66669H5.16602M11.8327 4.66669V11.3334'
            stroke='black'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </Suspense>
    </div>
  );
}
